var MainLayout = (function(window, $){

	var w = $(window),
		b = $('body'),
		hasScrolled = false,
		needsEqualHeight = false,
		equalHeightsObj = [];

	function init() {

		/*if($('.eh-container').length) {
			needsEqualHeight = true;
			initEqualHeights()
			supdateHeights();
		}*/

		initMainNavigation();
		initVideoPlay();
		initFaqForm();
		initFormSelect();
		initMoreContent();
		initOpenClose();
		goTop();


		throttle('scroll', 'optiScroll');
		//throttle('resize', 'optiResize');
		this.onScroll = onScroll.bind(this);
		//this.onResize = onResize.bind(this);
		window.addEventListener('optiScroll', this.onScroll);
		//window.addEventListener('optiResize', this.onResize);


		//anchors: fix header position
		if(window.location.hash) {
			setTimeout(function() {
				var headerHeight = $('header.main-header').height();
				var target = window.location.hash;
				if (!$(target).offset().top) return false;
				var scrollToPosition = $(target).offset().top - headerHeight;
				$('html,body').animate({ 'scrollTop': scrollToPosition }, 600, function(){
						window.location.hash = "" + target;
						// This hash change will jump the page to the top of the div with the same id
						// so we need to force the page to back to the end of the animation
					$('html,body').animate({ 'scrollTop': scrollToPosition }, 0);
				});
			}, 200);
		}

	}

	function initVideoPlay() {
		$('.video-module .play-btn').on('click', function(e){
			e.preventDefault();
			var vm = $(this.parentNode.parentNode.parentNode.parentNode.parentNode);
			vm.addClass('play');
		})
	}

	function initMainNavigation() {
		$('.navigation .trigger-open').on('click', function(e){
			e.preventDefault();
			$('.navigation').addClass('is-open');
			$('body').addClass('no-scrolling');
			$(document).on('touchmove', preventScrolling);
		});
		$('.navigation .trigger-close').on('click', function(e){
			e.preventDefault();
			$('.navigation').removeClass('is-open');
			$('body').removeClass('no-scrolling');
			$(document).off('touchmove', preventScrolling);
		});

		$(document.body).on("touchstart", ".navigation.is-open .wrapper", function (e) {
			// If the element is scrollable (content overflows), then...
			if (this.scrollHeight !== this.clientHeight) {
				// If we're at the top, scroll down one pixel to allow scrolling up
				if (this.scrollTop === 0) {
					this.scrollTop = 1;
				}
				// If we're at the bottom, scroll up one pixel to allow scrolling down
				if (this.scrollTop === this.scrollHeight - this.clientHeight) {
					this.scrollTop = this.scrollHeight - this.clientHeight - 1;
				}
			}
			// Check if we can scroll
			this.allowUp = this.scrollTop > 0;
			this.allowDown = this.scrollTop < (this.scrollHeight - this.clientHeight);
			this.lastY = e.originalEvent.pageY;
		});

		$(document.body).on('touchmove', ".navigation.is-open .wrapper", function(e) {
			var event = e.originalEvent;
			var up = event.pageY > this.lastY;
			var down = !up;
			this.lastY = event.pageY;

			if ((up && this.allowUp) || (down && this.allowDown)) {
				event.stopPropagation();
			} else {
				event.preventDefault();
			}
		});

		//menu width
		$('nav.primary>ul>li>ul').width($('nav.primary>ul>li').find('a').width());
		$('nav.primary>ul>li').on('mouseover', function(){
			$('nav.primary>ul>li>ul').css('transition','none').width($('nav.primary>ul>li').find('a').width());
		});

	}

	function preventScrolling(e){
		e.preventDefault();
	}

	function updateHeights() {
		for(var i = 0, j = equalHeightsObj.length; i < j; i++) {
			equalHeightsObj[i].setHeight();
		}
	}

	function initFormSelect() {
		$('.inquiry-form select').select2({
			minimumResultsForSearch: -1,
			theme:'form'
		});
	}

	function initFaqForm() {
		var frm = $('#faqform');
		//console.log(frm.length)
		$('input[type=checkbox]', frm).on('change', '', {form:frm}, function(e) {

			e.data.form.submit();
		});
	}

	/*function initEqualHeights() {
		var eh = $('.eh-container');
		for(var i = 0, j = eh.length; i < j; i++) {
			equalHeightsObj.push(new EqualHeights(eh[i], '.eh-item'));
		}
	}*/

	function goTop() {
		var button = $("a.go-top"),
				desktop = Modernizr.mq('all and (min-width: 1025px)');
		if (!desktop) {
			button.removeAttr('style');
		}
		else {
			if ($(window).scrollTop() > 400) button.fadeIn(700);
			else button.fadeOut(700)
		}
	}

	function onResize() {
		goTop();
		//needsEqualHeight ? updateHeights() : null;
	}

	function onScroll() {
		if(!hasScrolled && 150 < w.scrollTop()) {
			b.addClass('has-scrolled');
			hasScrolled = true;
		} else if (hasScrolled && 150 >= w.scrollTop()) {
			b.removeClass('has-scrolled');
			hasScrolled = false;
		}
		goTop();
	}

	function initMoreContent () {
		$('.show-more').on('click', function(e) {
			e.preventDefault();
			var t = $(this);
			var hidden = t.next();

			t.hide();
			hidden.css('height', $('.hidden-content', hidden).outerHeight()+'px');
			updateHeights();
		});
	}

	function initOpenClose () {
		//open-close (harmonica)
		var oc = $('div.open-close'),
				remoteTriggered = false;
		if(oc.length) {
			var trigger = oc.find('a.trigger');
			trigger.on('click', function(e){
				e.preventDefault();
				var t = $(this),
						openCloseGroup = t.parents('div.open-close'),
						el = t.parents('div.element'),
						els = openCloseGroup.find('div.element'),
						cid = el.attr('id');

					if(el.hasClass('is-open')){
						el.removeClass('is-open');

					} else {

						els.removeClass('is-open');
						el.addClass('is-open');

						//window.location.href = window.location.href +'#' + cid;



						$('html,body').animate({
							scrollTop: el.offset().top - $('header.main-header').height()
						}, 200);

						if (remoteTriggered) {
							setTimeout(function() {
								this.location.href = this.location.href;
								remoteTriggered = false;
							}, 100);
						}
					}
			});
		}

		$('a.go-top').click(function() {
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top
					}, 1000);
					return false;
				}
			}
		});
	}




	return {
		init:init
	}

}(window, jQuery));

$(document).ready(MainLayout.init);
